import { normalSanatizerBRL } from "src/utils/functions";
import { CDBResponse } from "../utilis/calculo";
export const CalculadoraCDBTable = ({ results }: { results: CDBResponse }) => {
  return (
    <div className="max-h-[400px] overflow-y-auto m-auto overflow-x-auto">
      <table className="bg-white rounded w-full max-h-[400px] overflow-y-auto">
        <thead className="bg-gray-200 sticky top-0">
          <tr>
            <th className="px-4 py-2 text-center truncate">Evento</th>
            <th className="px-4 py-2 text-center truncate">Descontos</th>
          </tr>
        </thead>
        <tbody>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              Valor final Bruto
            </td>
            <td className="px-4 py-2 text-center truncate border-r">
              R$ {normalSanatizerBRL(results.valorFinal)}
            </td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              Valor final Liquido
            </td>
            <td className="px-4 py-2 text-center truncate border-r">
              R$ {normalSanatizerBRL(results.valorFinalLiquido)}
            </td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              Imposto de Renda
            </td>
            <td className="px-4 py-2 text-center truncate border-r">
              R$ {normalSanatizerBRL(results.impostoRenda)}
            </td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              Rendimento Liquido
            </td>
            <td className="px-4 py-2 text-center truncate border-r">
              R$ {normalSanatizerBRL(results.rendimentoLiquido)}
            </td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              Rendimento Bruto
            </td>
            <td className="px-4 py-2 text-center truncate border-r">
              R$ {normalSanatizerBRL(results.rendimentoBruto)}
            </td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              Rendimento Bruto Percentual
            </td>
            <td className="px-4 py-2 text-center truncate border-r">
              {results.rendimentoBrutoPercentual}%
            </td>
          </tr>
          <tr className=" border-b">
            <td className="px-4 py-2 text-center truncate border-r">
              Taxa Anual CDB
            </td>
            <td className="px-4 py-2 text-center truncate border-r">
              {Math.round(results.taxaAnualCDB * 100) / 100}%
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
